import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TokenManager } from "@forgerock/javascript-sdk";
import { from, mergeMap, Observable } from "rxjs";
import { environment } from "src/environments/environment.generated";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const endpointSegments = Object.values(environment.endPoints);
        const shouldIntercept = req.url.startsWith(environment.apiBaseUrl) && endpointSegments.some(segment => req.url.includes(segment));

        if (!shouldIntercept || environment.mock) {
            return next.handle(req);
        }

        return from(TokenManager.getTokens()).pipe(
            mergeMap(
                tokens => {
                    if (tokens && tokens.accessToken) {
                        const cloned = req.clone({
                            setHeaders: {
                                Authorization: `Bearer ${tokens.accessToken}`
                            }
                        });
                        return next.handle(cloned);
                    } else {
                        return next.handle(req);
                    }
                }
            )
        )
    }
}